import { useContext } from 'react'

import { TableGridContext } from '@component/Layout/TableGridScrollSimilarProduct'

import type { ITableGridContext } from '@base/@types/components/Layout/TableGrid'

export default function useTableScrollProductSimilar(): ITableGridContext {
  const context = useContext(TableGridContext)

  return context
}
